import {
  GET_DETAIL_WORK_TIME_SUCCESS,
  GET_LIST_WORK_TIME,
  GET_LIST_WORK_TIME_SUCCESS,
  PAGINATION_DEFAULT,
  SET_LOADING_WORK_TIME,
} from "../../constants"
import { IWorkTimeState } from "../types"

interface ActionProps {
  type: string
  payload: any
}

const initState: IWorkTimeState = {
  list: {
    data: [],
    total: 0,
    limit: PAGINATION_DEFAULT.limit,
    offset: PAGINATION_DEFAULT.offset,
  },
  detail: {
    data: {},
  },
  isLoadingRequest: false,
  isDeleteRequest: false,
  isUpdateRequest: false,
  isCreateRequest: false,
}

export const workTime = (state: IWorkTimeState = initState, action: ActionProps) => {
  const { type, payload } = action

  switch (type) {
    case GET_LIST_WORK_TIME: {
      return {
        ...state,
      }
    }
    case GET_LIST_WORK_TIME_SUCCESS: {
      return {
        ...state,
        list: {
          ...state.list,
          data: payload.data,
          total: payload.total,
        },
      }
    }

    case GET_DETAIL_WORK_TIME_SUCCESS: {
      return {
        ...state,
        detail: {
          ...state.detail,
          data: payload.data,
        },
      }
    }

    case SET_LOADING_WORK_TIME: {
      return {
        ...state,
        ...payload,
      }
    }

    default: {
      return state
    }
  }
}
